export default __webpack_public_path__ + "static/media/407.f5e12438.png";